//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.ConnectorBuilder.js";
import "../Motion/Motion.SelectFieldData.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"ActionLinkOvrCtrl",1,0],[0,"ActionPointOvrCtrl",1,0],[1,"CoefficientCurveProfile",0,"Motion.SelectFieldData",0],[1,"CoefficientExpression",0,"Expression",0],[0,"CoefficientFunction",1,"CAE.Function",0],[0,"CoefficientType",1,0],[0,"DamperAppDirection",1,0],[0,"DamperCustomizedSolver",1,0],[1,"InnerCylinderRadiusExpression",0,"Expression",0],[0,"Name",1,0],[1,"OuterCylinderRadiusExpression",0,"Expression",0],[0,"ReactionLinkOvrCtrl",1,0],[0,"ReactionPointOvrCtrl",1,0],[0,"ShowVisualization",1,0],[1,"TorsionalCoefficientExpression",0,"Expression",0]],[],[]];
SPLM.Motion.DamperBuilder = class extends SPLM.Motion.ConnectorBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.DamperBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;